import { ModuleRouter } from "@/components/module-router/module-router";

export function CasaviRoutes() {
  return <ModuleRouter moduleId="casavi" />;
}
